export default "__VITE_ASSET__z1FF5dLZ__"